import { isString } from './stringUtils';

/**
 * Utility to filter query params, keeping only non-empty string or undefined values.
 * @param params The query params object to filter
 * @returns The filtered params
 */
export function filterQueryParams<T extends object>(params?: T): Record<string, any> {
  const entries = Object.entries((params ?? {}));
  return Object.fromEntries(entries
      .filter(([, value]) => (isString(value) ? value.trim() !== '' : value !== undefined))
      .map(([key, value]) => [key, value]));
}
